<template>
  <div class="pagination_PPagination float-right pb-3" v-if="lastPageNumber > 0">
    <PButton
      id="first-page-button"
      variant="gray-circle"
      icon="IconChevronsLeft"
      @click="onClickDirection(0)"
      :disabled="isFirstPageNumber"
    >
    </PButton>
    <PButton
      id="prev-page-button"
      variant="gray-circle"
      icon="IconChevronLeft"
      @click="onClickDirection(-1)"
      :disabled="isFirstPageNumber"
    >
    </PButton>

    <span class="page-number page-number-left current"> {{ currentPage }} </span>

    <span class="separator_PPagination">/</span>

    <span class="page-number page-number-right">
      {{ lastPageNumber }}
    </span>

    <PButton
      id="next-page-button"
      variant="gray-circle"
      icon="IconChevronRight"
      @click="onClickDirection(1)"
      :disabled="isLastPageNumber"
    >
    </PButton>
    <PButton
      id="last-page-button"
      variant="gray-circle"
      icon="IconChevronsRight"
      @click="onClickDirection(lastPageNumber)"
      :disabled="isLastPageNumber"
    >
    </PButton>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PIcon from "../PIcon/PIcon.vue";
import PButton from "../PButton/PButton.vue";

@Component({
  name: "pagination",
  components: {
    PIcon,
    PButton,
  },
})
export class PPagination extends Vue {
  @Prop({ required: true }) value!: number;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.currentPage = this.value;
  }
  @Prop({ required: true }) pageSize!: number;
  @Prop({ required: true }) totalElements!: number;

  currentPage = 1;
  constructor() {
    super();
  }

  get lastPageNumber(): number {
    return Math.ceil(this.totalElements / this.pageSize);
  }

  get isFirstPageNumber(): boolean {
    return this.currentPage === 1;
  }

  get isLastPageNumber(): boolean {
    return this.currentPage === this.lastPageNumber;
  }

  onClickDirection(factor: number): void {
    if (factor === 0) {
      this.currentPage = 1;
    } else if (factor === this.lastPageNumber) {
      this.currentPage = this.lastPageNumber;
    } else if (factor > 0) {
      this.currentPage++;
    } else if (factor < 0) {
      this.currentPage--;
    }
    this.$emit("input", this.currentPage);
    this.$emit("change", this.currentPage);
  }
}
export default PPagination;
</script>

<style lang="scss" scoped>
.pagination_PPagination {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 10px 0;
  justify-content: flex-end;
}
.separator_PPagination {
  margin: 0 7px;
  color: #d5d5d5;
}

.page-number {
  line-height: 1rem;
  color: var(--secundario-prosegur-oscuro);
}

.page-number-left {
  margin-left: 10px;
}

.page-number-right {
  color: #d5d5d5;
}

.current {
  color: var(--amarillo-prosegur);
}
</style>
